import React from "react";
import BaseDefault from "../../core/BaseDefault";

export default function Borders_Page(){
    return(
        <BaseDefault
            styles="title-page"
            title="Borders"
        >
            
        </BaseDefault>
    )
}